<template>
  <div>
    <v-dialog v-model="showDialog" persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="headline">{{ title }}</v-card-title>
        <v-card-text v-if="text" v-html="text" class="py-4"></v-card-text>
        <v-card-text v-if="hasTextInput" class="py-4">
          <v-text-field
            v-model="textfield"
            :placeholder="textInputPlaceholder"
            v-on:keyup.enter="action"
            ref="textfieldInput"
          ></v-text-field>
        </v-card-text>
        <v-card-actions class="pa-3">
          <v-alert
            v-if="message"
            border="left"
            colored-border
            type="error"
            elevation="2"
            class="my-0 hyp-alert application-heading"
            >{{ message }}</v-alert
          >
          <v-spacer></v-spacer>
          <v-btn v-if="buttonCancel" text @click="cancel()">{{
            buttonCancel.text
          }}</v-btn>
          <v-btn
            v-if="buttonAction"
            :disabled="buttonActionDisabled"
            color="success"
            @click="action"
          >
            {{ buttonAction.text }}
            <Loader
              v-if="buttonAction.loader && buttonAction.disabled"
              size="small"
              color="white"
              text=""
              class="ml-2"
            ></Loader>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import lodashIsFunction from "lodash/isFunction";

export default {
  name: "ConfirmationPopup",
  components: {
    Loader: () => import("@/components/common/Loader"),
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
    },
    text: {
      type: String,
    },
    buttonCancel: {
      type: Object,
    },
    buttonAction: {
      type: Object,
    },
    maxWidth: {
      type: Number,
      default: 400,
    },
    hasTextInput: {
      type: Boolean,
      default: false,
    },
    textInputPlaceholder: {
      type: String,
      default: "",
    },
    inputTextValue: {
      type: String,
    },
    message: {
      type: String,
      default: "",
    },
  },
  data: function () {
    return {
      dialog: null,
      textfield: this.inputTextValue ? this.inputTextValue : null,
    };
  },
  computed: {
    showDialog: {
      get() {
        if (this.dialog === null) {
          return this.show;
        }
        return this.dialog;
      },
      set(value) {
        this.dialog = value;
      },
    },
    buttonActionDisabled() {
      if (this.hasTextInput) {
        return !this.textfield;
      }
      return this.buttonAction.disabled;
    },
  },
  methods: {
    cancel() {
      this.showDialog = null;
      if (lodashIsFunction(this.buttonCancel.onClickFnc)) {
        this.buttonCancel.onClickFnc();
      }
    },
    action() {
      this.showDialog = null;
      if (lodashIsFunction(this.buttonAction.onClickFnc)) {
        let params = {};
        if (this.hasTextInput && this.textfield) {
          params.textfield = this.textfield;
        }
        this.buttonAction.onClickFnc(params);
      }
    },
  },
  watch: {
    show: {
      handler() {
        this.textfield = null;
        setTimeout(() => {
          if (this.$refs.textfieldInput) {
            this.$refs.textfieldInput.focus();
          }
        });
      },
    },
    textfield: {
      handler() {
        this.buttonAction.disabled = true;
        if (this.hasTextInput && this.textfield) {
          this.buttonAction.disabled = false;
        }
      },
    },
    "buttonAction.loader": {
      handler() {
        this.buttonAction.disabled = this.buttonAction.loader;
      },
    },
    inputTextValue: {
      handler() {
        this.textfield = this.inputTextValue ? this.inputTextValue : null;
      },
    },
  },
};
</script>

<style scoped></style>
